import { useEffect, useState } from "react";
import axios from "axios";
import { MessageCircle, Phone, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { API, errText, when } from "@/components/listings/common";

const RS = { new: ["Yeni", "sending"], contacted: ["Arandı", "scheduled"], closed: ["Kapandı", "draft"] };
const KINDS = { sell: "Satmak istiyor", rent: "Kiraya vermek istiyor" };

export function RequestsPanel({ onChanged }) {
  const [rows, setRows] = useState(null);
  const load = () => axios.get(`${API}/site-requests`).then((r) => setRows(r.data)).catch(() => toast.error("Talepler yüklenemedi"));
  useEffect(() => { load(); }, []);
  const update = async (x, status) => { try { await axios.put(`${API}/site-requests/${x.id}`, { status }); load(); onChanged(); } catch (e) { toast.error(errText(e)); } };
  const remove = async (x) => { if (!window.confirm("Talep silinsin mi?")) return; try { await axios.delete(`${API}/site-requests/${x.id}`); load(); onChanged(); } catch (e) { toast.error(errText(e)); } };
  if (!rows) return <p className="empty">Yükleniyor…</p>;
  if (!rows.length) return <div className="panel ig-empty" data-testid="requests-empty"><MessageCircle size={26} /><b>Henüz talep yok</b><span>Sitedeki "Evinizi satalım / kiralayalım" formundan gelen talepler burada görünür.</span></div>;
  return (
    <div className="lst-list" data-testid="requests-list">
      {rows.map((x) => { const [label, cls] = RS[x.status] || RS.new; const first = x.name.split(" ")[0]; return (
        <div key={x.id} className={`panel lst-req${x.status === "new" ? " fresh" : ""}`} data-testid={`request-${x.id}`}>
          <div className="lst-row-body">
            <div className="lst-row-top"><b>{x.name}</b><span className={`camp-status ${cls}`} data-testid={`request-status-${x.id}`}>{label}</span><small>{when(x.created_at)}</small></div>
            <p className="lst-row-title">{KINDS[x.kind]} · {x.category}{[x.district, x.city].some(Boolean) && ` · ${[x.district, x.city].filter(Boolean).join(", ")}`}{x.details && ` · ${x.details}`}</p>
            {x.message && <p className="lst-req-msg">{x.message}</p>}
          </div>
          <div className="lst-row-actions">
            <a className="outline-btn" href={`tel:${x.phone.replace(/[^\d+]/g, "")}`} data-testid={`request-call-${x.id}`}><Phone size={14} />{x.phone}</a>
            {x.wa && <a className="primary-btn lst-wa" href={`https://wa.me/${x.wa}?text=${encodeURIComponent(`Merhaba ${first}, Emlak Sepeti'nden yazıyorum. Mülkünüzle ilgili talebinizi aldık.`)}`} target="_blank" rel="noreferrer" data-testid={`request-wa-${x.id}`}><MessageCircle size={14} />WhatsApp</a>}
            <select value={x.status} onChange={(e) => update(x, e.target.value)} data-testid={`request-status-select-${x.id}`}>{Object.entries(RS).map(([k, [t]]) => <option key={k} value={k}>{t}</option>)}</select>
            <button className="icon-btn danger" onClick={() => remove(x)} title="Sil" data-testid={`request-delete-${x.id}`}><Trash2 size={15} /></button>
          </div>
        </div>
      ); })}
    </div>
  );
}
